import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-cancel-subscription",
  templateUrl: "./cancel-subscription.component.html",
  styleUrls: ["./cancel-subscription.component.scss"],
})
export class CancelSubscriptionComponent {
  form = {
    cancelReason: "",
  };

  constructor(private dialogRef: MatDialogRef<CancelSubscriptionComponent>) {}

  submit(): void {
    this.dialogRef.close(this.form);
  }

  close(): void {
    this.dialogRef.close();
  }
}
